import React, { useEffect } from "react";
import { graphql } from "gatsby";
import BundleIngredients from "../sections/BundleIngredients";
import Layout from "../layouts/default";
import Product from "../sections/Product";
import Bundle from "../sections/Bundle";
import BundleHowToUse from "../sections/BundleHowToUse";
import ProductReviews from "../sections/ProductReviews";
import { Helmet } from "react-helmet";

export const query = graphql`
  query ProductSet($id: String) {
    contentfulProductSet(id: { eq: $id }) {
      __typename
      slug
      name
      seo {
        pageTitle
        pageDescription {
          pageDescription
        }
      }
      shortDescription {
        shortDescription
      }
      description {
        raw
      }
      subscription
      customizable
      setItem {
        shopifyId
        title
        price
        product {
          title
        }
      }
      images {
        fluid(quality: 100) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      variants {
        id
        name
        volumeOrSize
        product {
          ... on ContentfulProduct {
            shopifyId
            name
            slug
            shortDescription {
              shortDescription
            }
            ingredients {
              raw
            }
            ingredientsImage {
              fluid {
                ...GatsbyContentfulFluid_withWebp
              }
            }
          }
        }
        subscription {
          price
          shopifyId
        }
        individual {
          price
          priceNumber
          shopifyId
        }
      }
      additionalVariants {
        id
        name
        volumeOrSize
        product {
          ... on ContentfulAccessories {
            name
            productImage {
              fluid {
                ...GatsbyContentfulFluid_withWebp
              }
            }
          }

          ... on ContentfulProduct {
            name
            shortDescription {
              shortDescription
            }
            productImage {
              fluid {
                ...GatsbyContentfulFluid_withWebp
              }
            }
            ingredients {
              raw
            }
            ingredientsImage {
              fluid {
                ...GatsbyContentfulFluid_withWebp
              }
            }
          }
        }
        subscription {
          price
          shopifyId
        }
        individual {
          price
          shopifyId
        }
      }
      customizerImages {
        title
        file {
          url
          details {
            image {
              width
            }
          }
        }
        fluid {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      groupSwatch {
        fluid {
          ...GatsbyContentfulFluid_withWebp
        }
      }
      morningRoutine {
        stepTitle
        stepImage {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        extraCopy {
          extraCopy
        }
      }
      nightRoutine {
        stepTitle
        stepImage {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        extraCopy {
          extraCopy
        }
      }
    }
  }
`;

export default function ProductBundleTemplate({ data, location }) {
  useEffect(() => {
    if (window && location.search.length) {
      const params = new URLSearchParams(location.search);

      if (params.get("sid")) {
        window.sessionStorage.setItem(params.get("sid"), params.get("subid"));
      }
    }
  }, [location]);

  return (
    <Layout pathName={location.pathname}>
      <Helmet>
        <title>
          {data.contentfulProductSet?.seo?.pageTitle ||
            data.contentfulProductSet.name}
        </title>
        <meta
          name="description"
          content={
            data.contentfulProductSet?.seo?.pageDescription.pageDescription
          }
        />
        <meta
          property="og:image"
          content={data.contentfulProductSet.images[0].fluid.src}
        />
      </Helmet>
      {data.contentfulProductSet.customizable ? (
        <Bundle set={data.contentfulProductSet} />
      ) : (
        <Product product={data.contentfulProductSet} />
      )}
      <BundleIngredients data={data.contentfulProductSet} />
      <BundleHowToUse data={data.contentfulProductSet} />
      {/* <ProductReviews product={data.contentfulProductSet} /> */}
    </Layout>
  );
}
